const installmentManagers = $('[data-installment-manager]');

for (const installmentManager of installmentManagers) {

    const $installmentManager = $(installmentManager);
    const $installmentList = $('#installment-list');
    const $installmentsForm = $('#installmentsForm');

    $installmentManager.installmentManager({
        token: $installmentManager.data('installmentManagerToken'),
        endpoint: $installmentManager.data('installmentManagerEndpoint'),
        success: function (bin_results) {

            $installmentList.html('');

            if (bin_results.installments && bin_results.installments.length > 1) {

                $installmentList.append(`<input type="hidden" name="card_sub_brand" value="${bin_results.card_sub_brand}">`);

                for (const {installment_amount, total_with_interest} of bin_results.installments) {

                    $installmentList.append(
                        `<tr class="cursor-pointer" data-check-radio>
                                <td>
                                    <input type="radio"
                                    name="installment_amount"
                                    value="${installment_amount}"
                                    id="installment_${installment_amount}"
                                    ${installment_amount === "" ? 'checked' : ''}
                                    class="stylish-radio valign-middle mr-2">
                                    <label for="installment_${installment_amount}">${installment_amount === "" ? translates.cash : installment_amount + ' ' + translates.installment}</label>
                                </td>
                                <td>${App.prototype.currencyFormat(total_with_interest / (installment_amount === "" ? 1 : installment_amount))} ${translates.currency_code}</td>
                                <td>${App.prototype.currencyFormat(total_with_interest)} ${translates.currency_code}</td>
                            </tr>`
                    )

                }

                $installmentsForm.show();

            }

        },
        error: function (data) {

            $installmentsForm.hide();

            $installmentList.html('');

            // console.error('error', data);

        },
        complete: function (data) {

            // console.warn('warn', data);

        }
    });

}


$(document).on('click', '[data-check-radio]', function () {
    $(this).find('input[type=radio]').click();
});

$(document).on('change', 'input[name="installment_amount"]', function () {

    App.prototype.getCart({
        delivery_type_id: $('input[name$="delivery_type_id"]:checked').val(),
        payment_method_id: $('input[name$="payment_method_id"]:checked').val(),
        installment_amount: $('input[name="installment_amount"]:checked').val()
    });

});
